// extracted by mini-css-extract-plugin
export default {"playerWrapper":"ResponsivePlayer_playerWrapper__+mJG5","reactPlayer":"ResponsivePlayer_reactPlayer__mGXhJ"};